import type { Expand } from "@pdfking/tfunc"
import { object_map } from "@pdfking/rfunc"
import { IsString } from "@pdfking/tfunc"

type ProxyResult<K extends string, T> = Expand<{
  [P in K]: { get: () => T; set: (v: T) => void }
}>

export default <K extends string, T>(
  object: Record<string, T>,
  keys: K[] | Record<string, K>
): ProxyResult<K, T> =>
  object_map(
    (n: string) => n,
    (n: string, k: string | number) => {
      const target = IsString(k) ? (k as string) : n
      return {
        get: () => object[target],
        set: (v: T) => (object[target] = v),
      }
    },
    // @ts-expect-error - union type K[] | Record<K, string> not matched by overloads
    keys
  ) as ProxyResult<K, T>
